import { 
	GET_STORE_OVERALLS_GARMENTS, 
	GET_STORE_OVERALLS_GARMENT,
	CREATE_STORE_OVERALLS_GARMENT,
	UPDATE_STORE_OVERALLS_GARMENT,
	DESTROY_STORE_OVERALLS_GARMENT,
} from "./actions"

export function StoreOverallsGarmentsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_STORE_OVERALLS_GARMENTS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_STORE_OVERALLS_GARMENT}_FULFILLED`:
		case `${CREATE_STORE_OVERALLS_GARMENT}_FULFILLED`:
		case `${UPDATE_STORE_OVERALLS_GARMENT}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_STORE_OVERALLS_GARMENT}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { StoreOverallsGarmentsReducer } from "modules/store/overalls/garments/reducer"

// store_overalls_garments:StoreOverallsGarmentsReducer,
